import {
     SURVEY_REPORTS_SURVEY_SELECTED,
     SURVEY_REPORTS_LIST_SURVEYS,
     SURVEY_REPORTS_USER_RESULTS,
     SURVEY_REPORTS_PREVIEW_PDF_RESULTS,
     SURVEY_REPORTS_SELECTED_START_DATE,
     SURVEY_REPORTS_SELECTED_END_DATE,
     SURVEY_REPORTS_LIST_EVENT,
     SURVEY_REPORTS_LIST_EVENT_SELECTED,
} from './actions';

const initState = {
     listSurveys: [],
     listEvent: null,
     surveySelected: '',
     listEventSelected: [],
     userSurveyResults: {},
     startDate: '',
     endDate: '',
};

const surveyReportsReducer = (state = initState, action) => {
     switch (action.type) {
          case SURVEY_REPORTS_LIST_SURVEYS:
               return {
                    ...state,
                    listSurveys: action.payload,
               };
          case SURVEY_REPORTS_SURVEY_SELECTED:
               return {
                    ...state,
                    surveySelected: action.payload,
               };
          case SURVEY_REPORTS_USER_RESULTS:
               return {
                    ...state,
                    userSurveyResults: action.payload,
               };
          case SURVEY_REPORTS_PREVIEW_PDF_RESULTS:
               return {
                    ...state,
                    previewPdfSurveyResults: action.payload,
               };
          case SURVEY_REPORTS_SELECTED_START_DATE:
               return {
                    ...state,
                    startDate: action.payload,
               };
          case SURVEY_REPORTS_SELECTED_END_DATE:
               return {
                    ...state,
                    endDate: action.payload,
               };
          case SURVEY_REPORTS_LIST_EVENT:
               return {
                    ...state,
                    listEvent: action.payload,
               };
          case SURVEY_REPORTS_LIST_EVENT_SELECTED:
               return {
                    ...state,
                    listEventSelected: action.payload,
               };
          default:
               return state;
     }
};

export default surveyReportsReducer;
